<template>
  <div></div>
</template>

<script setup lang="ts">
import { onBeforeMount } from "vue";
import { useRouter, useRoute } from "vue-router";
const route = useRoute();
const router = useRouter();

onBeforeMount(() => {
  const token = route.query.token;
  router.push({ name: "AssessmentVendorExternalCallback", query: { token } });
});
</script>
